var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('the-header',{ref:"theHeader"}),_c('div',{staticClass:"main d-flex flex-column"},[_c('div',{staticClass:"quarter-embed"},[_c('b-embed',{attrs:{"type":"iframe","aspect":"21by9","src":_vm.url1,"width":_vm.width,"height":_vm.height}})],1)]),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }